import { motion } from 'framer-motion'

import Img from './assets/sprites/Frame 9.webp'
import { useScrollingOrnament } from './useScrollingOrnament'

const SLIDES_COUNT = 8
const SLIDE_MAX_INDEX = 4
const VIEWPORT_HEIGHT = 77
const OFFSET = 0

export const Ornament5 = () => {
  const { ref, slideNum } = useScrollingOrnament(
    SLIDES_COUNT,
    VIEWPORT_HEIGHT,
    OFFSET,
    SLIDE_MAX_INDEX
  )

  return (
    <div ref={ref}>
      <svg
        viewBox={`0 0 759 ${VIEWPORT_HEIGHT - 2}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.image href={Img} width="759" x="0" y={slideNum} />
      </svg>
    </div>
  )
}
